import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const FAQSection = () => {
  const [expandedIndex, setExpandedIndex] = useState(0);

  const faqs = [
    {
      id: 1,
      question: "How often will I receive the THEPS Newsletter?",
      answer: "The THEPS Newsletter is delivered every Monday morning directly to your inbox. Each edition is carefully curated to provide you with the most relevant funding opportunities, agency updates, and project-writing insights for the week ahead."
    },
    {
      id: 2,
      question: "Can I unsubscribe anytime?",
      answer: "Absolutely! You can unsubscribe with one click at any time. No questions asked, no hassle. We respect your time and inbox."
    },
    {
      id: 3,
      question: "How do you protect my privacy?",
      answer: "We never sell, rent, or share your email address. We're GDPR compliant and CAN-SPAM compliant. Your data is encrypted and stored securely. Read our full privacy policy for details."
    }
  ];

  const toggleFAQ = (index) => {
    setExpandedIndex(expandedIndex === index ? -1 : index);
  };

  return (
    <section className="py-16 lg:py-24 bg-background">
      <div className="max-w-4xl mx-auto px-5 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-heading font-bold text-foreground mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-lg text-muted-foreground">
            Everything you need to know about THEPS Newsletter
          </p>
        </div>

        <div className="space-y-4">
          {faqs?.map((faq, index) => (
            <div
              key={faq?.id}
              className="bg-card border border-border rounded-lg shadow-elevation-sm overflow-hidden transition-all duration-300 ease-smooth"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full flex items-center justify-between p-6 text-left hover:bg-muted/50 transition-colors duration-250"
                aria-expanded={expandedIndex === index}
              >
                <span className="text-lg font-heading font-semibold text-foreground pr-4">
                  {faq?.question}
                </span>
                <Icon
                  name={expandedIndex === index ? "ChevronUp" : "ChevronDown"}
                  size={20}
                  className="flex-shrink-0 text-muted-foreground"
                />
              </button>

              <div
                className={`transition-all duration-300 ease-smooth ${
                  expandedIndex === index
                    ? 'max-h-96 opacity-100' :'max-h-0 opacity-0 overflow-hidden'
                }`}
              >
                <div className="px-6 pb-6 text-muted-foreground leading-relaxed">
                  {faq?.answer}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;